import { Injectable, NgZone } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { AppService } from '../app.service';
import { AuthOIDCService } from '../auth/authOIDC.service';

@Injectable()
export class AuthGuard implements CanActivate {

    constructor(
        public authOIDCService: AuthOIDCService,
        public appService: AppService,
        public ngZone: NgZone
    ) {}

    canActivate( next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
        if(!this.authOIDCService.token){
            this.onAuthInit();
            return false;
        } else return true;
    }

    onAuthInit(): void {
		this.authOIDCService.AuthInit()
        .then((isAuth:boolean) => {
            this.ngZone.run(() => {   
                if(isAuth){
                    console.log('isAuth', true);
                    this.appService.ngOnInitConfig();
                }             
            })
        }).catch(err => {
            console.log('deeplink app component auth init error', err);
        });
    }

}
